// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","viewAsSelect":"_2pESKR-xspzsdxVWStfDOx","returnIcon":"_1kPG_ivvUX7kwaHWS-cXpI"};